import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ExternalAuthGuard } from "./auth/external-auth.guard";
import { AdminOnlyGuard } from "./auth/admin-only.guard";
import { LogsAccessGuard } from "./auth/logs-access.guard";
import { ContractsEnabledGuard } from "./auth/contracts-enabled.guard";
import { Layout } from "gojs";
import { LayoutComponent } from "./pages/layout/layout.component";

export const routes: Routes = [
  {
    path: "",
    canActivate: [ExternalAuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: "companies",
        loadChildren: () =>
          import("src/app/modules/company-list/company-list.module").then(
            (m) => m.CompanyListModule
          ),
      },
      {
        path: "create",
        loadChildren: () =>
          import("src/app/modules/company-create/company-create.module").then(
            (m) => m.CompanyCreateModule
          ),
      },
      {
        path: "company",
        loadChildren: () =>
          import("src/app/modules/company-view/company-view.module").then(
            (m) => m.CompanyViewModule
          ),
      },
      {
        path: "map",
        loadChildren: () =>
          import("src/app/modules/corporate-full-map/corporate-full-map.module").then(
            (m) => m.CorporateFullMapModule
          ),
      },
      {
        path: "library",
        loadChildren: () =>
          import(
            "src/app/modules/document-library/document-library.module"
          ).then((m) => m.DocumentLibraryModule),
      },
      {
        path: "docs",
        loadChildren: () =>
          import("src/app/modules/document-list/document-list.module").then(
            (m) => m.DocumentListModule
          ),
      },
      {
        path: "document",
        loadChildren: () =>
          import("src/app/modules/document-view/document-view.module").then(
            (m) => m.DocumentViewModule
          ),
      },
      {
        path: "users",
        canActivate: [AdminOnlyGuard],
        loadChildren: () =>
          import("src/app/modules/users/users.module").then(
            (m) => m.UsersModule
          ),
      },
      {
        path: "logs",
        canActivate: [LogsAccessGuard],
        loadChildren: () =>
          import("src/app/modules/logs/logs.module").then(
            (m) => m.LogsModule
          ),
      },
      {
        path: "individuals",
        loadChildren: () =>
          import("src/app/modules/individuals/individuals.module").then(
            (m) => m.IndividualsModule
          ),
      },
      {
        path: "contracts",
        canActivate: [ContractsEnabledGuard],
        loadChildren: () =>
          import("src/app/modules/contracts/contracts.module").then(
            (m) => m.ContractsModule
          ),
      },
      {
        path: "alerts",
        loadChildren: () =>
          import("src/app/modules/alerts/alerts.module").then(
            (m) => m.AlertsModule
          ),
      },
      {
        path: "expirations",
        redirectTo: "alerts/vencimientos",
        pathMatch: "prefix",
      },
      {
        path: "administration",
        canActivate: [AdminOnlyGuard],
        loadChildren: () =>
          import("src/app/modules/administration/administrations.module").then(
            (m) => m.AdministrationsModule
          ),
      },
      /* {
        path: 'registral',
        loadChildren: () =>
          import('src/app/modules/registral/registral.module').then(
            (m) => m.RegistralModule
          ),
      },*/
      {
        path: "information",
        loadChildren: () =>
          import(
            "src/app/modules/information-shared/information-shared.module"
          ).then((m) => m.InformationSharedModule),
      },
       {
        path: 'upload',
        loadChildren: () =>
          import('src/app/modules/powers-upload/powers-upload.module').then(
            (m) => m.PowersUploadModule
          ),
      },
      { path: "", redirectTo: "companies", pathMatch: "full" },
      { path: "**", redirectTo: "companies", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
